import { BaseDto } from './base.dto';

export class City extends BaseDto {
  x?: number;
  y?: number;
  area?: string;
  name?: string;
}
